<header class="page-header">
  <div class="page-header__heading">
    <h1 class="page-header__title">{{title}}</h1>
    @if (tag) {
      <span class="page-header__tag">{{tag}}</span>
    }
  </div>
  @if (backLinkRoute) {
    <a class="page-header__back" routerLink={{backLinkRoute}}>
      <mat-icon>arrow_back</mat-icon> {{backLinkLabel}}
    </a>
  }
  @if (subtitle) {
    <p class="page-header__subtitle">{{subtitle}}</p>
  }
  <div class="page-header__accessory">
    <ng-content></ng-content>
  </div>
</header>
